import { useEffect, useRef } from 'react';

export const usePolling = (task, interval = 7000, enabled = true) => {
    const taskRef = useRef(task);

    useEffect(() => {
        taskRef.current = task;
    });

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        let timeoutId = null;
        let stopped = false;
        let running = false;

        const schedule = () => {
            timeoutId = setTimeout(tick, interval);
        };

        const tick = async () => {
            if (stopped || running) {
                return;
            }

            if (document.visibilityState !== 'visible') {
                schedule();
                return;
            }

            running = true;

            try {
                await taskRef.current();
            } finally {
                running = false;

                if (!stopped) {
                    schedule();
                }
            }
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                clearTimeout(timeoutId);
                tick();
            }
        };

        document.addEventListener('visibilitychange', onVisibilityChange);
        schedule();

        return () => {
            stopped = true;
            clearTimeout(timeoutId);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [enabled, interval]);
};
